function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      width: ", ";\n      height: ", ";\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React, { useContext, useMemo } from 'react';
import styled, { css, ThemeContext } from 'styled-components';
import { addStyleIfPropTruly } from "../../../utils/styledComponents";
import { ImageSizes } from "../theme";
import { mediaSmDown } from "../../../theme/helpers/media";
import { PRODUCT_IMAGE_TEST_ID } from "../constants";

var getBackgroundSize = function getBackgroundSize(size, src) {
  if (!src) return 'auto 83%';
  return size === ImageSizes.full ? 'cover' : 'contain';
};

var getPlaceholder = function getPlaceholder(pics) {
  if (typeof pics === 'string') return pics;
  return pics[Math.floor(Math.random() * pics.length)];
};

var Image = styled.div.attrs(function (_ref) {
  var src = _ref.src,
      size = _ref.size,
      $placeholder = _ref.$placeholder;
  return {
    'data-testid': PRODUCT_IMAGE_TEST_ID,
    style: {
      backgroundImage: "url(".concat(src || $placeholder, ")"),
      backgroundSize: "".concat(getBackgroundSize(size, src))
    }
  };
}).withConfig({
  displayName: "Image",
  componentId: "sc-57vdla-0"
})(["", ";background-repeat:no-repeat;background-position:center;", ";"], function (_ref2) {
  var size = _ref2.size,
      imageSizeMobile = _ref2.theme.imageSizeMobile;
  return css(["width:200px;height:180px;", ""], mediaSmDown(_templateObject(), imageSizeMobile[size].width, imageSizeMobile[size].height));
}, addStyleIfPropTruly('disabled', 'opacity: .6;'));

var ImageWithPlaceholder = function ImageWithPlaceholder(props) {
  var _useContext = useContext(ThemeContext),
      defaultProductPic = _useContext.defaultProductPic;

  var placeholder = useMemo(function () {
    return defaultProductPic && getPlaceholder(defaultProductPic);
  }, [defaultProductPic]);
  return React.createElement(Image, _extends({}, props, {
    $placeholder: placeholder
  }));
};

export default ImageWithPlaceholder;